"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.title.placeholder': 'Inserisci titolo della conoscenza',
};
